import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import decimalComSufixoNullableComponent from "@/components/child/form/decimalComSufixoNullable.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import infoBagdeComponent from "@/components/child/infoBagde/infoBagde.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { ModalButtonAction } from "@/components/child/modal/modalButtonAction";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import UploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo";
import uploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo.vue";
import { Component, Prop, Watch } from "@/decorators";
import AliquotaInterestadualModel from "@/models/aliquotaInterestadualModel";
import CorManipulacao from "@/models/enum/corManipulacao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TipoCapsula from "@/models/enum/manipulacao/tipoCapsula";
import OrigemProdutoLote from "@/models/enum/origemProdutoLote";
import CurvaABC from "@/models/enum/produto/curvaABC";
import TipoCalculoAssociacao from "@/models/enum/tipoCalculoAssociacao";
import TipoObservacao from "@/models/enum/tipoObservacao";
import TiposCalculoManipulacao from "@/models/enum/tiposCalculoManipulacao";
import TiposProduto from "@/models/enum/tiposProduto";
import Ufs from "@/models/enum/ufs";
import FormaFarmaceuticaModel from "@/models/formaFarmaceuticaModel";
import FornecedorModel from "@/models/fornecedorModel";
import IncompatibilidadeKitEmbalagemModel from "@/models/incompatibilidadeKitEmbalagemModel";
import IncompatibilidadeProdutoModel from "@/models/incompatibilidadeProdutoModel";
import PaginationModel from "@/models/paginationModel";
import PosologiaModel from "@/models/posologiaModel";
import NcmModel from "@/models/produto/ncmModel";
import ProdutoAssociacaoModel from "@/models/produto/produtoAssociacaoModel";
import ProdutoFornecedorModel from "@/models/produto/produtoFornecedorModel";
import ProdutoModel from "@/models/produto/produtoModel";
import ProdutoObservacoesModel from "@/models/produto/produtoObservacoesModel";
import ProdutoSinonimoModel from "@/models/produto/produtoSinonimoModel";
import ProdutoAliquotaInterestadualModel from "@/models/produtoAliquotaInterestadualModel";
import ProdutoFormaFarmaceuticaModel from "@/models/produtoFormaFarmaceuticaModel";
import ProdutoLogFinanceiroModel from "@/models/produtoLogFinanceiroModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import ProdutoMarkupDinamicoModel from "@/models/produtoMarkupDinamicoModel";
import ProdutoPerecivelFormaFarmaceuticaModel from "@/models/produtoPerecivelFormaFarmaceuticaModel";
import ProdutoRefrigeradoFormaFarmaceuticaModel from "@/models/produtoRefrigeradoFormaFarmaceuticaModel";
import UsuarioModel from "@/models/usuarioModel";
import ValidadeFormaFarmaceuticaProdutoModel from "@/models/validadadeFormaFarmaceuticaProdutoModel";
import capsulaService from "@/services/capsulaService";
import codigoSiproquimService from "@/services/codigoSiproquimService";
import corService from "@/services/corService";
import EstoqueComprometidoService from "@/services/estoqueComprometidoService";
import estoqueService from "@/services/estoqueService";
import farmacopeiaService from "@/services/farmacopeiaService";
import formaFarmaceuticaService from "@/services/formaFarmaceuticaService";
import FornecedorService from "@/services/fornecedorService";
import franquiaService from "@/services/franquiaService";
import kitEmbalagemService from "@/services/kitEmbalagemService";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import OrigemMercadoriaService from "@/services/origemMercadoriaService";
import cestService from "@/services/produto/cestService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import listaControladoService from "@/services/produto/listaControladoService";
import nbmService from "@/services/produto/nbmService";
import produtoDcbService from "@/services/produto/produtoDcbService";
import produtoDciService from "@/services/produto/produtoDciService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import setorService from "@/services/setorService";
import situacaoTributariaService from "@/services/situacaoTributariaService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { AppState, Getters, SessionActions } from "@/store/store";
import { BaseOption, GrupoProdutoOption } from "@/types/options";
import arithmeticHelper from "@/utils/common/arithmeticHelper";
import { changePosition } from "@/utils/common/array";
import { getFornecedorCombo, getPosologiaCombo } from "@/utils/common/combo/combotext";
import { editDateWithTime } from "@/utils/common/date";
import Delay from "@/utils/common/delay";
import { AcaoController, DescricaoTela } from "@/utils/common/permissionConstants";

import ImprimirRotuloPersonalizadoComponent from "../../crud/rotulopersonalizado/imprimirRotuloComModal";
import imprimirRotuloPersonalizadoComponent from "../../crud/rotulopersonalizado/imprimirRotuloComModal.vue";
import FichaTecnicaEditComponent from "../../fichaTecnica/edit";
import fichaTecnicaComponent from "../../fichaTecnica/edit.vue";
import shortcutComponent from "../../shortcut/shortcut.vue";
import SolicitarSenhaComponent from "../../solicitarSenha/view";
import solicitarSenhaComponent from "../../solicitarSenha/view.vue";
import PosologiaComponent from "../posologia/edit";
import posologiaComponent from "../posologia/edit.vue";
import ReplicarSelecaoFranquiaComponent from "../replicarSelecaoFranquia/edit";
import replicarSelecaoFranquiaComponent from "../replicarSelecaoFranquia/edit.vue";

import ShortcutComponent from "./../../shortcut/shortcut";
import ProdutoLogFinanceiroComponent from "./../produtologfinanceiro/list";
import produtoLogFinanceiroComponent from "./../produtologfinanceiro/list.vue";
import { origensFamilia, tiposFamilia } from "./familiaSeniorHierarquia";
import ReplicarProdutoComponent from "./replicarProduto";
import replicarProdutoComponent from "./replicarProduto.vue";
import { custoReferenciaTooltipText, valorCustoTooltipText } from "./tooltipText";
import verLoteComponent from "./verLote.vue";

import "../crud.scss";
import "./edit.scss";

@Component({
    components: {
        textareaComponent,
        comboComponent,
        fieldsetComponent,
        checkboxComponent,
        dataTooltipComponent,
        searchComboComponent,
        gridComponent,
        moedaComponent,
        decimalComponent,
        posologiaComponent,
        decimalComSinalCustomComponent,
        decimalComSufixoNullableComponent,
        replicarSelecaoFranquiaComponent,
        replicarProdutoComponent,
        shortcutComponent,
        solicitarSenhaComponent,
        produtoLogFinanceiroComponent,
        verLoteComponent,
        imprimirRotuloPersonalizadoComponent,
        fichaTecnicaComponent,
        buttonIncluirComponent,
        actionBarComponent,
        logEntidadeComponent,
        infoBagdeComponent,
        uploadAnexoComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters([
            "HAS_PERMISSAO_PERFIL",
            "VALIDAR_PERMISSAO_USUARIO",
            "VALIDAR_PERMISSAO_SOMENTE_CONSULTA",
            "GET_IS_FRACIONAMENTO",
            "GET_IS_ESTEREIS",
            "GET_FRANQUIA_IS_ESTEREIS",
        ] as Getters),
        infoBagdeText() {
            return "Data criação: " + editDateWithTime(this.model.dataCriacao);
        },
    },
})
export default class ProdutoEditComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;
    VALIDAR_PERMISSAO_SOMENTE_CONSULTA: (telaDescricao: string) => boolean;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;
    GET_FRANQUIA_IS_ESTEREIS: () => Promise<boolean>;
    infoBagdeText: string;

    private serviceLote = new ProdutoLoteService();
    private shortcutComponent: ShortcutComponent = null;
    private shortcutAliquotaInterestadualComponent: ShortcutComponent = null;
    private shortcutFichaTecnicaComponent: ShortcutComponent = null;
    private shortcutTrocarUnidadeMedidaComponent: ShortcutComponent = null;
    private fichaTecnicaComponent: FichaTecnicaEditComponent = null;
    private posologiaComponent: PosologiaComponent = null;
    private shortcutLogComponent: ShortcutComponent = null;
    private replicarSelecaoFranquiaComponent: ReplicarSelecaoFranquiaComponent = null;
    private replicarProdutoComponent: ReplicarProdutoComponent = null;
    private imprimirRotuloPersonalizadoComponent: ImprimirRotuloPersonalizadoComponent = null;
    private uploadAnexoComponent: UploadAnexoComponent = null;
    private solicitarSenhaComponent: SolicitarSenhaComponent = null;
    private validadesOriginais = "";
    model = new ProdutoModel();
    modelId = 0;
    id = 0;
    loteId = 0;
    loadLote = false;

    private simplesNacional = false;

    somenteConsulta = false;
    showFinanceiro = false;
    loadCompleted = false;

    private franquiaUf = "";
    private ufs = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);
    private aliquotasICMSInterestadualDefault: Array<AliquotaInterestadualModel> = [];

    private isAdmin = false;
    private isAdminSuporteFranqueado = false;
    private isAdminFranqueador = false;
    private franquiaId: number = null;
    private hasCodigoFranquiaModeloEdit = false;
    extraActions: Array<object> = [];
    gridExtraActionsVer: Array<GridAction> = [];
    gridExtraActionsImprimirRotulo: Array<GridAction> = [];
    gridExtraActionsDefinirLotePadrao: Array<GridAction> = [];
    extraActionsProdutoFornecedor: Array<object> = [];
    extraActionsUp: Array<GridAction> = [];
    extraActionsDown: Array<GridAction> = [];

    franquiaOptions: Array<Object> = [];
    grupoProdutoOptions: GrupoProdutoOption[] = [];
    unidadesMedidaOptions = [];
    listasControladoOptions: Array<Object> = [];
    nbmsOptions: Array<Object> = [];
    fornecedoresOptions: Array<Object> = [];
    estoquesOptions: Array<Object> = [];

    cestsOptions: Array<Object> = [];
    dcbsOptions: Array<Object> = [];
    dcisOptions: Array<Object> = [];
    capsulasOptions: Array<Object> = [];
    produtoAssOptions: Array<Object> = [];
    produtoDiluidoOptions: Array<Object> = [];
    produtoFranquiaModeloOptions: Array<Object> = [];
    tiposCalculoOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(TiposCalculoManipulacao);
    tipoCalculoAssociacaoOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(TipoCalculoAssociacao);
    formasFarmaceuticaOptions = [];
    kitEmbalagemOptions: Array<Object> = [];
    setorOptions: Array<Object> = [];
    subGrupoOptions: Array<Object> = [
        { text: "Ativo", value: 0 },
        { text: "Flavorizante", value: 1 },
        { text: "Veículos/Excipientes", value: 2 },
        { text: "Sólido", value: 8 },
        { text: "Semissólido", value: 9 },
        { text: "Líquido", value: 10 },
    ];
    tipoCapsulaOptions: Array<Object> = [
        { text: "Normal", value: TipoCapsula.Normal },
        { text: "Revestida", value: TipoCapsula.Revestida },
        { text: "Vegana", value: TipoCapsula.Vegana },
        { text: "Vegana Revestida", value: TipoCapsula.VeganaRevestida },
        { text: "Pullulan", value: TipoCapsula.Pullulan },
    ];
    farmacopeiaOptions: Array<Object> = [];
    observacaoTipoOptions: Array<Object> = [
        { text: "Venda de Manipulação", value: TipoObservacao.VendaManipulacao },
        { text: "Ordem de Manipulação", value: TipoObservacao.OrdemManipulacao },
        { text: "Conservação e Transporte", value: TipoObservacao.ConservacaoTransporte },
        { text: "Exibir aviso no orçamento", value: TipoObservacao.ExibirAvisoOrcamento },
    ];

    corManipulacaoOptions: Array<Object> = [
        { text: "Vermelho", value: CorManipulacao.Vermelho },
        { text: "Roxo", value: CorManipulacao.Roxo },
        { text: "Verde", value: CorManipulacao.Verde },
        { text: "Azul", value: CorManipulacao.Azul },
        { text: "Laranja", value: CorManipulacao.Laranja },
        { text: "Amarelo", value: CorManipulacao.Amarelo },
    ];

    curvaABCOptions: Array<Object> = [
        { text: "A", value: CurvaABC.A },
        { text: "B", value: CurvaABC.B },
        { text: "C", value: CurvaABC.C },
    ];

    tipoProdutoImpostoOptions: Array<Object> = [
        { text: "0-Não classificado", value: 0 },
        { text: "1-Mercadorias", value: 1 },
        { text: "2-Matérias primas", value: 2 },
        { text: "3-Produtos intermediários", value: 3 },
        { text: "4-Materiais de embalagem", value: 4 },
        { text: "5-Produtos manufaturados", value: 5 },
        { text: "6-Em fabricação", value: 6 },
        { text: "7-Subproduto", value: 7 },
        { text: "8-Material de uso e consumo", value: 8 },
        { text: "9-Ativo imobilizado", value: 9 },
        { text: "10-Serviços", value: 10 },
        { text: "11-Outros insumos", value: 11 },
        { text: "99-Outras", value: 99 },
    ];

    criterioRateioOptions: Array<Object> = [
        { text: "1-Receita - Conta x Centro de Custo", value: 1 },
        { text: "2-Receita - Centro de Custo x Conta", value: 2 },
        { text: "3-Despesa - Conta x Centro de Custo", value: 3 },
        { text: "4-Despesa - Centro de Custo x Conta", value: 4 },
        { text: "5-Nenhum", value: 5 },
    ];

    controleValidadeOptions: Array<Object> = [
        { text: "Obriga Informação", value: "O" },
        { text: "Desativa Campo", value: "D" },
        { text: "Livre", value: "L" },
    ];

    tipoProdutoSeniorOptions: Array<Object> = [
        { text: "Produzido", value: "P" },
        { text: "Comprado", value: "C" },
        { text: "Montagem", value: "M" },
        { text: "Passagem Direta", value: "D" },
        { text: "Serviço", value: "S" },
    ];

    enquadramentoProdutoEspecificoOptions: Array<Object> = [
        { text: "0-Produto Normal", value: 0 },
        { text: "1-Medicamento", value: 1 },
        { text: "2-Combustível", value: 2 },
        { text: "3-Armamento", value: 3 },
        { text: "4-Cana de açúcar", value: 4 },
        { text: "5-Medicamento Controlado", value: 5 },
        { text: "9-Outros (sujeito a rastreabilidade)", value: 9 },
    ];

    tipoFamiliaOptions = tiposFamilia;

    get origemFamiliaOptions(): Array<Object> {
        if (!this.model.tipoFamilia) {
            return [];
        }
        return origensFamilia
            .filter(o => o.tipo === this.model.tipoFamilia)
            .map(o => ({ text: o.text, value: o.value }));
    }

    get familiaOptions(): Array<Object> {
        if (!this.model.origemFamilia) {
            return [];
        }
        const origem = origensFamilia.find(o => o.value === this.model.origemFamilia);
        return origem ? origem.familias : [];
    }

    filtroVinculos: number;
    origemMercadoriaOptions: Array<Object> = [];
    cstICMSOptions: Array<Object> = [];
    cstIPIEntradaOptions: Array<Object> = [];
    cstIPISaidaOptions: Array<Object> = [];
    cstPISCOFINSEntradaOptions: Array<Object> = [];
    cstPISCOFINSSaidaOptions: Array<Object> = [];
    cstIBSCBSOptions: Array<Object> = [];
    coresOptions: Array<Object> = [];
    produtosIncompatibilidadeOptions: Array<Object> = [];
    produtosRefrigeradosOptions: Array<Object> = [];
    produtosPereciveisOptions: Array<Object> = [];
    kitEmbalagensIncompatibilidadeOptions: Array<Object> = [];
    formaFarmaceuticaIncompatibilidadeOptions: Array<Object> = [];
    ufOptions: Array<Object> = this.ufs;

    codigoSiproquimOptions: Array<Object> = [];
    naturezaOperacaoOptions: BaseOption[] = [];

    percentualAssociacao?: number = null;
    excipienteAssociacao?: boolean = false;
    desmembradoAssociacao?: boolean = false;
    produtoAssociacaoId?: number = null;
    formaFarmaceuticaAssociacaoId?: number = null;
    tipoCalculoAssociacao?: TipoCalculoAssociacao = TipoCalculoAssociacao.Ativo;
    totalLote = 0;
    private siglaEstoqueDescricao = "";
    addNewId = 0;

    private valorCustoTooltipText = valorCustoTooltipText;
    private custoReferenciaTooltipText = custoReferenciaTooltipText;
    observacaoTipo = 0;
    observacaoTexto = "";
    produtoIncompativelId = 0;
    kitEmbalagemIncompativelId = 0;
    produtoRefrigeradoFormaceuticaId = 0;
    produtoPerecivelFormaceuticaId = 0;
    formaFarmaceuticaIncompativelId = 0;
    produtoFornecedorId = 0;
    refreshDataProdutosAliquotasInterestaduais = false;
    formaFarmaceuticaValidadeId: number = null;
    diasValidadeForma = 0;
    ufAliquotaInterestadual = 0;
    aliquotaInterestadual = 0;
    unidadeMedidaEstoqueIdDestino: number = null;

    unidadeMedidaEstoqueDescricao = "";
    unidadeMedidaManipulacaoDescricao = "";

    private customComboTextNCM = (p: NcmModel) => ({
        value: p.id,
        text: `${p.codigo} ${!p.ativo ? "[INATIVO] " : ""}- (${p.descricao})`,
    });
    private customComboTextPosologia = getPosologiaCombo;

    produtoSinonimo = "";
    descricaoRotulo = "";
    fatorEquivalencia = 0;
    indexEdditingProdutoSinonimo = null;

    private usaMarkupDinamico = false;

    private showLog = false;
    private loadFichaTecnicaComponent = false;
    private isIndustria = false;
    private isEstereis = false;

    private produtoLogFinanceiroComponent: ProdutoLogFinanceiroComponent = null;

    gridColumnsFormaFarmaceutica: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
    ];

    gridColumnsFormaFarmaceuticaEmb: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
    ];

    gridColumnsProdutoAssociacoes: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Forma Farm.", GridColumnType.String),
        new GridColumn("produtoAssociadoDescricao", "Produto", GridColumnType.String),
        new GridColumn("percentual", "Percentual", GridColumnType.Decimal),
        new GridColumn("excipiente", "Excipiente", GridColumnType.Boolean),
        new GridColumn("desmembrado", "Desmembrado", GridColumnType.Boolean),
        new GridColumn("tipoCalculoAssociacaoDescricao", "Cálculo", GridColumnType.String),
    ];

    gridDataLote: Array<ProdutoLoteModel> = [];
    get gridColumnLote(): Array<GridColumn> {
        return [
            new GridColumn("descricao", "Descri\u00e7\u00e3o", GridColumnType.String),
            new GridColumn("fornecedorNome", "Fornecedor", GridColumnType.String),
            new GridColumn("fatorCorrecao", "F.C", GridColumnType.Decimal),
            new GridColumn("valorCusto", "Custo Unitário", GridColumnType.Money4Digits, false, !this.showFinanceiro),
            new GridColumn("dataValidade", "Validade", GridColumnType.Date),
            new GridColumn("dataFabricacao", "Fabrica\u00e7\u00e3o", GridColumnType.Date),
            new GridColumn("quantidadeAtual", "Quantidade", GridColumnType.Decimal),
            new GridColumn("quantidadeComprometida", "Qtd. Comprometida", GridColumnType.Decimal),
        ];
    }

    gridColumnsProdutoSinonimos: Array<GridColumn> = [
        new GridColumn("sinonimo", "Sinônimo", GridColumnType.String),
        new GridColumn("descricaoRotulo", "Descrição Rótulo", GridColumnType.String),
        new GridColumn("fatorEquivalencia", "Fator de Equivalência", GridColumnType.Decimal),
    ];

    gridColumnsObservacoes: Array<GridColumn> = [
        new GridColumn("tipoDescricao", "Tipo de Observação", GridColumnType.String),
        new GridColumn("texto", "Observação", GridColumnType.String),
    ];

    gridColumnsProdutosIncompativeis: Array<GridColumn> = [
        new GridColumn("produtoIncompativelDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
        new GridColumn("formaFarmaceuticaIncompativelDescricao", "Descrição Forma Farmacêutica", GridColumnType.String),
    ];

    gridColumnsProdutoRefrigeradoFormaFarmaceutica: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Forma Farmacêutica Refrigerada", GridColumnType.String),
    ];

    gridColumnsProdutoPerecivelFormaFarmaceutica: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Forma Farmacêutica Perecível", GridColumnType.String),
    ];

    gridColumnsProdutoFornecedor: Array<GridColumn> = [
        new GridColumn("fornecedorDescricao", "Nome Fornecedor", GridColumnType.String),
        new GridColumn("ordem", "Ordem", GridColumnType.Integer),
    ];

    gridColumnsKitEmbalagemIncompativeis: Array<GridColumn> = [
        new GridColumn(
            "kitEmbalagemIncompativelDescricao",
            "Descrição Kit Embalagem Incompatível",
            GridColumnType.String,
        ),
    ];

    gridColumnsFormaFarmaceuticaValidades: Array<GridColumn> = [
        new GridColumn("formaFarmaceuticaDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
        new GridColumn("diasValidade", "Validade em Dias", GridColumnType.Integer),
    ];

    gridColumnsAliquotasInterestaduais: Array<GridColumn> = [
        new GridColumn("ufDestino", "UF", GridColumnType.String),
        new GridColumn("aliquota", "Alíquota", GridColumnType.Decimal),
    ];

    get extraButtonActionFichaTecnica(): Array<ModalButtonAction> {
        return [
            new ModalButtonAction("resultados", this.$t("__.ts.Resultado").toString(), true, "i", " btn-warning"),
            new ModalButtonAction("imprimir", this.$t("__.ts.imprimir").toString(), true, "i", " btn-info"),
        ];
    }

    private bloqueiaEdicaoSenior = false;

    @Prop({ type: Boolean, default: false }) isModal: boolean;
    @Prop(String) descricaoSugestao: string;

    public async load() {
        this.model = new ProdutoModel();

        this.isIndustria = (await this.GET_IS_FRACIONAMENTO()) || (await this.GET_IS_ESTEREIS());
        this.isEstereis = await this.GET_FRANQUIA_IS_ESTEREIS();

        const isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        const temPermissao = this.VALIDAR_PERMISSAO_USUARIO(DescricaoTela.produtos, AcaoController.seniorUpdate);
        this.bloqueiaEdicaoSenior = !isAdmin && !temPermissao;

        if (this.modelId > 0) {
            try {
                const data = await produtoService
                    .getById(this.modelId, 0.1, false)
                    .withLoading()
                    .resolveWithJSON<ProdutoModel>();
                this.model.updateFrom(data);

                this.usaMarkupDinamico = this.model.produtoMarkupDinamico.length > 0;
                this.model.produtoMarkupDinamico = this.model.produtoMarkupDinamico.sort((a, b) =>
                    Number(a.demaisValores) < Number(b.demaisValores) ? 1 : -1,
                );

                if (this.model.unidadeMedidaEstoqueId > 0) {
                    const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

                    const unidadeMedidaEstoque = unidadeMedida.find(p => p.value == this.model.unidadeMedidaEstoqueId);
                    if (unidadeMedidaEstoque) {
                        this.siglaEstoqueDescricao = unidadeMedidaEstoque.text;
                    }
                }

                this.model.produtoObservacoes = this.model.produtoObservacoes.map(obs => {
                    const observacao = new ProdutoObservacoesModel();
                    observacao.id = obs.id;
                    observacao.texto = obs.texto;
                    observacao.tipo = obs.tipo;
                    observacao.tipoDescricao = this.observacaoTipoOptions[obs.tipo]["text"];
                    return observacao;
                });

                this.franquiaId = data.franquiaId;

                this.model.produtoAssociacoes = this.model.produtoAssociacoes.map(p => {
                    const assoc = new ProdutoAssociacaoModel();
                    assoc.updateFrom(p);
                    assoc.tipoCalculoAssociacaoDescricao = !assoc.excipiente
                        ? EnumExtensions.getNameByValue(TipoCalculoAssociacao, assoc.tipoCalculoAssociacao)
                        : null;
                    return assoc;
                });

                await this.loadProdutosIncompatibilidadeOptions();
                this.loadKitEmbalagemIncompatibilidadeOptions();
                await this.loadFormaFarmaceuticaIncompatibilidadeOptions();
                await this.loadProdutosRefrigeradosOptions();
                await this.loadProdutosPereciveisOptions();

                for (let i = 0; i < this.model.validadesFormasFarmaceuticasProdutos.length; i++) {
                    const forma = this.formasFarmaceuticaOptions.filter(
                        f => f["value"] == this.model.validadesFormasFarmaceuticasProdutos[i].formaFarmaceuticaId,
                    )[0];
                    this.model.validadesFormasFarmaceuticasProdutos[i].formaFarmaceuticaDescricao = forma["text"];
                }

                this.validadesOriginais = this.getStringsValidades();

                this.refreshDataProdutosAliquotasInterestaduais = true;

                this.loadUfsAliquotasInterestaduais();

                const lotes = await this.serviceLote
                    .listFilterProduto(data.id, null, null, 1, 999999)
                    .withLoading()
                    .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

                const lotesVadidos = lotes.list.filter(p => !p.loteFoiFracionado);
                lotesVadidos.forEach(item => {
                    if (item.origemProdutoLote == OrigemProdutoLote.Fracionamento) {
                        item.quantidadeAtual = item.quantidadeAtual * item.volumeFracionado;
                    }
                });

                this.totalLote = lotesVadidos.reduce((acc, p) => arithmeticHelper.round(acc + p.quantidadeAtual, 4), 0);
                this.gridDataLote = lotesVadidos;

                const quantidadesComprometidas = await new EstoqueComprometidoService()
                    .getQuantidadeComprometidaLotesByIds(lotesVadidos.map(p => p.id))
                    .withLoading()
                    .resolveWithJSON<{ id: number; quantidadeComprometida: number }[]>();

                this.gridDataLote.forEach(p => {
                    p.quantidadeComprometida = quantidadesComprometidas.filter(
                        q => q.id == p.id,
                    )[0].quantidadeComprometida;
                });

                this.loadGridProdutoLote();
                this.loadGridProdutoFornecedores(true);
            } catch {
                this.$router.back();
            }

            this.loadCompleted = true;
        } else if (this.descricaoSugestao != null && this.isModal) {
            this.model.descricao = this.descricaoSugestao;
        }
    }

    public constructor() {
        super();
    }

    public async save() {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
            this.$focusErrorField();
            return false;
        }

        if (
            this.isEstereis &&
            this.hasChangesValidades() &&
            !this.VALIDAR_PERMISSAO_USUARIO("produtos", "HasPermissaoAlteracaoValidade")
        ) {
            this.solicitarSenhaComponent = this.$refs.solicitarSenha as SolicitarSenhaComponent;
            this.solicitarSenhaComponent.show();
            return false;
        }

        return await this.continueSave();
    }

    private getStringsValidades(): string {
        return (this.model.validadesFormasFarmaceuticasProdutos ?? [])
            .map(validade => `${validade.formaFarmaceuticaId}:${validade.diasValidade}`)
            .sort()
            .join("|");
    }

    private hasChangesValidades(): boolean {
        return this.getStringsValidades() !== this.validadesOriginais;
    }

    private async onResultSolicitarSenha(sucesso: boolean) {
        if (sucesso) {
            await this.continueSave();
        } else {
            await this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.senhaInvalidaOuSemPermissaoValidade"));
        }
    }

    private async continueSave() {
        try {
            const isValid = await this.$validator.validateAll();

            if (isValid) {
                const response = await produtoService[!this.model.id ? "insert" : "update"](
                    this.model,
                    this.usuarioLogado.franquiaId,
                );

                if (response.ok) {
                    const nId = Number(response.headers.get("Id"));

                    this.onSucessoSave(nId);

                    if (
                        this.model.tipoProduto == TiposProduto.Capsula &&
                        this.model.capsulaId != null &&
                        this.model.ordemCapsula == null
                    ) {
                        await this.defineOrdemCoresCapsulas();
                    }

                    await this.$showInclusaoUpdate(this.model.id);
                    if (!this.model.id) {
                        this.model.id = nId;
                    }

                    if (this.isModal) {
                        this.$emit("save-ok", this.model);
                        return true;
                    } else if (
                        this.usuarioLogado.franquiaId != this.model.franquiaId &&
                        this.model.franquiaId != null
                    ) {
                        this.load();
                    } else {
                        this.$router.back();
                    }
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}

        return false;
    }

    private async defineOrdemCoresCapsulas() {
        try {
            let cores = await capsulaService.produtosCores(this.model.capsulaId);
            cores = cores.sort((a, b) =>
                a.ordemCapsula > b.ordemCapsula && a.ordemCapsula != null && b.ordemCapsula != null ? 1 : -1,
            );

            let ordermNormal = 1;
            let ordemGastrorresistente = 1;
            let ordemVegana = 1;
            let ordemVeganaRevestida = 1;
            let ordemPullulan = 1;

            const produtosOrdem = cores.map(p => {
                let produto = new ProdutoModel();
                produto = p;

                if (p.tipoCapsula == TipoCapsula.Normal) {
                    produto.ordemCapsula = ordermNormal;
                    ordermNormal++;
                }
                if (p.tipoCapsula == TipoCapsula.Revestida) {
                    produto.ordemCapsula = ordemGastrorresistente;
                    ordemGastrorresistente++;
                }
                if (p.tipoCapsula == TipoCapsula.Vegana) {
                    produto.ordemCapsula = ordemVegana;
                    ordemVegana++;
                }
                if (p.tipoCapsula == TipoCapsula.VeganaRevestida) {
                    produto.ordemCapsula = ordemVeganaRevestida;
                    ordemVeganaRevestida++;
                }
                if (p.tipoCapsula == TipoCapsula.Pullulan) {
                    produto.ordemCapsula = ordemPullulan;
                    ordemPullulan++;
                }
                return produto;
            });

            await capsulaService.salvarOrdem(produtosOrdem);
        } catch {}
    }

    private cancel() {
        this.$router.back();
    }

    private async loadUnidadesMedida() {
        try {
            this.unidadesMedidaOptions = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId, true);
        } catch {}
    }

    private async loadCSTs() {
        this.simplesNacional = this.usuarioLogado.franquia?.opcaoSimplesNacional;

        if (this.simplesNacional) {
            this.cstICMSOptions = situacaoTributariaService
                .getCSOSN()
                .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        } else {
            this.cstICMSOptions = situacaoTributariaService
                .getICMS()
                .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        }

        this.cstIPIEntradaOptions = situacaoTributariaService
            .getIPI()
            .filter(item => Number(item.codigo) < 50)
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        this.cstIPISaidaOptions = situacaoTributariaService
            .getIPI()
            .filter(item => Number(item.codigo) >= 50)
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        this.cstPISCOFINSEntradaOptions = situacaoTributariaService
            .getPISCOFINS()
            .filter(item => Number(item.codigo) >= 50)
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));
        this.cstPISCOFINSSaidaOptions = situacaoTributariaService
            .getPISCOFINS()
            .filter(item => Number(item.codigo) < 50)
            .map(item => ({ value: Number(item.codigo), text: `${item.codigo}-${item.descricao}` }));

        this.origemMercadoriaOptions = new OrigemMercadoriaService()
            .get()
            .map(item => ({ value: item.codigo, text: `${item.codigo}-${item.descricao}` }));

        this.cstIBSCBSOptions = situacaoTributariaService.getIBSCBS();
    }

    private onInclusaoFormaFarmaceuticaValidade() {
        const formaFarmaceuticaValidade = this.$el.querySelector("#formaFarmaceuticaValidadeId") as HTMLSelectElement;

        if (this.formaFarmaceuticaValidadeId > 0 && this.diasValidadeForma > 0) {
            const temForma =
                this.model.validadesFormasFarmaceuticasProdutos.filter(
                    f => f.formaFarmaceuticaId == this.formaFarmaceuticaValidadeId,
                ).length > 0;

            if (!temForma) {
                const validade = new ValidadeFormaFarmaceuticaProdutoModel();

                validade.formaFarmaceuticaId = this.formaFarmaceuticaValidadeId;
                validade.formaFarmaceuticaDescricao = formaFarmaceuticaValidade.innerText;
                validade.produtoId = this.model.id;
                validade.diasValidade = this.diasValidadeForma;
                this.model.validadesFormasFarmaceuticasProdutos.push(validade);

                this.formaFarmaceuticaValidadeId = null;
                this.diasValidadeForma = 0;
            }
        }
    }

    private onInclusaoFormaFarmaceutica() {
        const formaFarmaceuticaComponent = this.$el.querySelector("#formaFarmaceuticaId") as HTMLSelectElement;

        if (this.model.formaFarmaceuticaId > 0) {
            const alreadyExists =
                this.model.formasFarmaceuticas.filter(p => p.id == this.model.formaFarmaceuticaId).length > 0;

            if (!alreadyExists) {
                const formaFarmaceuticaModel = new ProdutoFormaFarmaceuticaModel();

                formaFarmaceuticaModel.formaFarmaceuticaId = this.model.formaFarmaceuticaId;
                formaFarmaceuticaModel.produtoId = this.model.id;
                formaFarmaceuticaModel.formaFarmaceuticaDescricao = formaFarmaceuticaComponent.innerText;
                this.model.formasFarmaceuticas.push(formaFarmaceuticaModel);

                this.model.formaFarmaceuticaId = -1;
            }
        }
    }

    private async loadProdutosIncompatibilidadeOptions() {
        const data = await produtoService.comboCached(this.usuarioLogado.franquiaId);
        this.produtosIncompatibilidadeOptions = data.filter(
            p =>
                p.value != this.model.id &&
                this.model.produtosIncompativeis.filter(i => i.produtoIncompativelId == p.value).length == 0,
        );
    }

    private async loadProdutosRefrigeradosOptions() {
        const formasFarmaceuticas = await formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId);
        this.produtosRefrigeradosOptions = formasFarmaceuticas.filter(
            p =>
                p.id != this.model.id &&
                this.model.produtoRefrigeradoFormaFarmaceutica.filter(i => i.formaFarmaceuticaId == p.id).length == 0 &&
                p.ativo,
        );
    }

    private async loadProdutosPereciveisOptions() {
        const formasFarmaceuticas = await formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId);
        this.produtosPereciveisOptions = formasFarmaceuticas.filter(
            p =>
                p.id != this.model.id &&
                this.model.produtoPerecivelFormaFarmaceutica.filter(i => i.formaFarmaceuticaId == p.id).length == 0 &&
                p.ativo,
        );
    }

    private async loadFornecedoresOptions() {
        try {
            const data = await new FornecedorService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<FornecedorModel>>();

            this.fornecedoresOptions = data.list
                .filter(p => !this.model.produtoFornecedores.some(item => item.fornecedorId === p.id))
                .map(getFornecedorCombo);
        } catch {}
    }

    private async loadFranquiaModeloCombo() {
        try {
            this.produtoFranquiaModeloOptions = await produtoService
                .getFranquiaModeloCombo()
                .withLoading()
                .resolveWithJSON<Array<Object>>();
        } catch {}
        return [];
    }

    private loadKitEmbalagemIncompatibilidadeOptions() {
        this.kitEmbalagensIncompatibilidadeOptions = this.kitEmbalagemOptions.filter(
            p => !this.model.kitEmbalagemIncompatibilidade.some(i => i.kitEmbalagemIncompativelId == p["value"]),
        );
    }

    private async loadFormaFarmaceuticaIncompatibilidadeOptions() {
        const formasFarmaceuticas = await formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId);
        this.formaFarmaceuticaIncompatibilidadeOptions = formasFarmaceuticas.filter(
            p =>
                p.id != this.model.id &&
                this.model.produtosIncompativeis.filter(i => i.produtoIncompativelId == p.id).length == 0 &&
                p.ativo,
        );
    }

    private async onInclusaoProdutoAssociacao() {
        const formaFarmaceuticaComponent = this.$el.querySelector(
            "#formaFarmaceuticaAssociacaoId",
        ) as HTMLSelectElement;
        const produtoAssociacaoComponent = this.$el.querySelector("#produtoAssociacaoId") as HTMLSelectElement;

        if (
            this.formaFarmaceuticaAssociacaoId &&
            this.produtoAssociacaoId &&
            ((this.percentualAssociacao && this.percentualAssociacao > 0) || this.excipienteAssociacao)
        ) {
            const alreadyExists =
                this.model.produtoAssociacoes.filter(
                    p =>
                        p.formaFarmaceuticaId == this.formaFarmaceuticaAssociacaoId &&
                        p.produtoAssociadoId == this.produtoAssociacaoId,
                ).length > 0;

            const possuiQsp =
                this.model.produtoAssociacoes.filter(
                    p =>
                        p.formaFarmaceuticaId == this.formaFarmaceuticaAssociacaoId &&
                        this.excipienteAssociacao &&
                        p.excipiente,
                ).length > 0;

            if (possuiQsp) {
                return this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.jaExisteAssocExcipiente"));
            }

            if (!alreadyExists && !possuiQsp) {
                const associacao = new ProdutoAssociacaoModel();

                associacao.formaFarmaceuticaId = this.formaFarmaceuticaAssociacaoId;
                associacao.formaFarmaceuticaDescricao = formaFarmaceuticaComponent.innerText;

                associacao.produtoAssociadoId = this.produtoAssociacaoId;

                let descricaoProdutoAssociacao = produtoAssociacaoComponent.innerText;
                const data = await produtoService.comboCached(this.usuarioLogado.franquiaId);
                const associado = data.filter(p => p.value == this.produtoAssociacaoId);
                if (associado.length > 0) {
                    descricaoProdutoAssociacao = associado[0].descricao;
                }

                associacao.produtoAssociadoDescricao = descricaoProdutoAssociacao;

                //quando eh excipiente, salva com 100 no percentual ?
                associacao.percentual = !this.excipienteAssociacao ? this.percentualAssociacao : 100;

                associacao.excipiente = this.excipienteAssociacao;

                associacao.desmembrado = this.desmembradoAssociacao && this.excipienteAssociacao;

                if (!this.excipienteAssociacao) {
                    associacao.tipoCalculoAssociacao = this.tipoCalculoAssociacao;
                    associacao.tipoCalculoAssociacaoDescricao = EnumExtensions.getNameByValue(
                        TipoCalculoAssociacao,
                        this.tipoCalculoAssociacao,
                    );
                }

                this.model.produtoAssociacoes.push(associacao);
            }
        }
    }

    private onInclusaoProdutoSinonimo() {
        if (this.indexEdditingProdutoSinonimo != null) {
            this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].sinonimo = this.produtoSinonimo;
            this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].fatorEquivalencia = this.fatorEquivalencia;
            this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].descricaoRotulo = this.descricaoRotulo;
            this.produtoSinonimo = "";
            this.descricaoRotulo = "";
            this.fatorEquivalencia = 0;
        } else {
            if (this.produtoSinonimo.length > 0) {
                const alreadyExists = this.model.produtoSinonimos.some(
                    sinonimo => sinonimo.sinonimo == this.produtoSinonimo,
                );
                if (!alreadyExists) {
                    const sinonimo = new ProdutoSinonimoModel();
                    sinonimo.sinonimo = this.produtoSinonimo;
                    sinonimo.descricaoRotulo = this.descricaoRotulo;
                    sinonimo.fatorEquivalencia = this.fatorEquivalencia;

                    this.model.produtoSinonimos.push(sinonimo);
                    this.produtoSinonimo = "";
                    this.descricaoRotulo = "";
                    this.fatorEquivalencia = 0;
                }
            }
        }
        this.indexEdditingProdutoSinonimo = null;
    }

    private async onEditProdutoSinonimos(produtoSinonimo: ProdutoSinonimoModel) {
        this.indexEdditingProdutoSinonimo = this.model.produtoSinonimos.indexOf(produtoSinonimo);

        if (this.indexEdditingProdutoSinonimo >= 0) {
            this.produtoSinonimo = this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].sinonimo;
            this.descricaoRotulo = this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].descricaoRotulo;
            this.fatorEquivalencia = this.model.produtoSinonimos[this.indexEdditingProdutoSinonimo].fatorEquivalencia;
        }
    }

    private onInclusaoProdutoObservacao() {
        if (this.observacaoTexto != "" && this.observacaoTipo != null) {
            const observacao = new ProdutoObservacoesModel();
            observacao.tipo = this.observacaoTipo;
            observacao.tipoDescricao = this.observacaoTipoOptions[this.observacaoTipo]["text"];
            observacao.texto = this.observacaoTexto;
            this.model.produtoObservacoes.push(observacao);
            this.observacaoTipo = 0;
            this.observacaoTexto = "";
        }
    }

    private async onInclusaoProdutoIncompativel() {
        if (this.produtoIncompativelId > 0 && this.model.id !== this.produtoIncompativelId) {
            const temProduto =
                this.model.produtosIncompativeis.filter(p => p.id == this.produtoIncompativelId).length > 0;

            if (!temProduto) {
                const incompatibilidade = new IncompatibilidadeProdutoModel();
                incompatibilidade.produtoId = this.model.id;
                incompatibilidade.produtoIncompativelId = this.produtoIncompativelId;
                incompatibilidade.produtoIncompativelDescricao = (
                    this.$el.querySelector("#produtoIncompativelId") as HTMLSelectElement
                ).innerText;

                if (this.formaFarmaceuticaIncompativelId > 0) {
                    incompatibilidade.formaFarmaceuticaIncompativelId = this.formaFarmaceuticaIncompativelId;
                    incompatibilidade.formaFarmaceuticaIncompativelDescricao = (
                        this.$el.querySelector("#formaFarmaceuticaIncompativelId") as HTMLSelectElement
                    ).innerText;
                }
                this.model.produtosIncompativeis.push(incompatibilidade);
                this.produtoIncompativelId = null;
                this.formaFarmaceuticaIncompativelId = null;

                await this.loadProdutosIncompatibilidadeOptions();
                await this.loadFormaFarmaceuticaIncompatibilidadeOptions();
            }
        }
    }

    private async onInclusaoProdutoRefrigerado() {
        if (this.produtoRefrigeradoFormaceuticaId > 0) {
            const alreadyExists =
                this.model.produtoRefrigeradoFormaFarmaceutica.filter(
                    p => p.formaFarmaceuticaId == this.produtoRefrigeradoFormaceuticaId,
                ).length > 0;

            if (!alreadyExists) {
                const produtoRefrigeradoFormaFarmaceutica = new ProdutoRefrigeradoFormaFarmaceuticaModel();
                produtoRefrigeradoFormaFarmaceutica.formaFarmaceuticaId = this.produtoRefrigeradoFormaceuticaId;
                produtoRefrigeradoFormaFarmaceutica.produtoId = this.model.id;
                produtoRefrigeradoFormaFarmaceutica.formaFarmaceuticaDescricao = (
                    this.$el.querySelector("#produtoRefrigeradoFormaceuticaId") as HTMLSelectElement
                ).innerText;

                this.model.produtoRefrigeradoFormaFarmaceutica.push(produtoRefrigeradoFormaFarmaceutica);
                this.produtoRefrigeradoFormaceuticaId = null;
                await this.loadProdutosRefrigeradosOptions();
            }
        }
    }

    private async onInclusaoProdutoPerecivel() {
        if (this.produtoPerecivelFormaceuticaId > 0) {
            const alreadyExists =
                this.model.produtoPerecivelFormaFarmaceutica.filter(
                    p => p.formaFarmaceuticaId == this.produtoPerecivelFormaceuticaId,
                ).length > 0;

            if (!alreadyExists) {
                const produtoPerecivelFormaFarmaceutica = new ProdutoPerecivelFormaFarmaceuticaModel();
                produtoPerecivelFormaFarmaceutica.formaFarmaceuticaId = this.produtoPerecivelFormaceuticaId;
                produtoPerecivelFormaFarmaceutica.produtoId = this.model.id;
                produtoPerecivelFormaFarmaceutica.formaFarmaceuticaDescricao = (
                    this.$el.querySelector("#produtoPerecivelFormaceuticaId") as HTMLSelectElement
                ).innerText;

                this.model.produtoPerecivelFormaFarmaceutica.push(produtoPerecivelFormaFarmaceutica);
                this.produtoPerecivelFormaceuticaId = null;
                await this.loadProdutosPereciveisOptions();
            }
        }
    }

    private onInclusaoProdutoFornecedor() {
        if (this.produtoFornecedorId > 0) {
            const alreadyExists =
                this.model.produtoFornecedores.filter(p => p.fornecedorId == this.produtoFornecedorId).length > 0;

            if (!alreadyExists) {
                const produtoFornecedor = new ProdutoFornecedorModel();
                produtoFornecedor.fornecedorId = this.produtoFornecedorId;
                produtoFornecedor.produtoId = this.model.id;
                produtoFornecedor.ordem = this.model.produtoFornecedores.length + 1;
                produtoFornecedor.fornecedorDescricao = (
                    this.$el.querySelector("#produtoFornecedorId") as HTMLSelectElement
                ).innerText;

                this.model.produtoFornecedores.push(produtoFornecedor);
                this.produtoFornecedorId = null;
                this.loadFornecedoresOptions();
                this.loadGridProdutoFornecedores();
            }
        }
    }

    private onInclusaoKitEmbalagemIncompativel() {
        if (
            this.kitEmbalagemIncompativelId > 0 &&
            !this.model.kitEmbalagemIncompatibilidade.some(
                x => x.kitEmbalagemIncompativelId == this.kitEmbalagemIncompativelId,
            )
        ) {
            const temProduto = this.model.kitEmbalagemIncompatibilidade.some(
                p => p.kitEmbalagemIncompativelId == this.kitEmbalagemIncompativelId,
            );

            if (!temProduto) {
                const incompatibilidade = new IncompatibilidadeKitEmbalagemModel();
                incompatibilidade.produtoId = this.model.id;
                incompatibilidade.kitEmbalagemIncompativelId = this.kitEmbalagemIncompativelId;
                incompatibilidade.kitEmbalagemIncompativelDescricao = (
                    this.$el.querySelector("#kitEmbalagemIncompativelId") as HTMLSelectElement
                ).innerText;

                this.model.kitEmbalagemIncompatibilidade.push(incompatibilidade);
                this.kitEmbalagemIncompativelId = null;

                this.loadKitEmbalagemIncompatibilidadeOptions();
            }
        }
    }

    private async loadUfsAliquotasInterestaduais() {
        const data = this.ufs;
        this.ufOptions = data.filter(
            p => this.model.produtoAliquotasInterestaduais.filter(i => i.ufDestino == p.text).length == 0,
        );
    }

    private async onInclusaoUfAliquotaInterestadual() {
        if (this.ufAliquotaInterestadual > 0 && this.aliquotaInterestadual > 0) {
            const ufDescricao = EnumExtensions.getNameByValue(Ufs, this.ufAliquotaInterestadual);
            const temUf = this.model.produtoAliquotasInterestaduais.filter(p => p.ufDestino == ufDescricao).length > 0;

            if (!temUf) {
                const aliquotaInterestadual = new ProdutoAliquotaInterestadualModel();
                aliquotaInterestadual.produtoId = this.model.id;
                aliquotaInterestadual.ufDestino = ufDescricao;
                aliquotaInterestadual.aliquota = this.aliquotaInterestadual;

                this.model.produtoAliquotasInterestaduais.push(aliquotaInterestadual);
                this.ufAliquotaInterestadual = null;
                this.aliquotaInterestadual = null;

                this.loadUfsAliquotasInterestaduais();
            }
        }
    }

    private async onShowAliquotasInterestaduais() {
        this.franquiaUf = EnumExtensions.getNameByValue(Ufs, this.usuarioLogado.franquia.estadoId);
        this.aliquotasICMSInterestadualDefault = await produtoService
            .getAliquotasICMSInterestadualDefault()
            .resolveWithJSON<AliquotaInterestadualModel[]>();

        this.model.produtoAliquotasInterestaduais.forEach(p => {
            const aliquota = this.aliquotasICMSInterestadualDefault.filter(a => a.ufDestino == p.ufDestino);
            aliquota[0].aliquota = p.aliquota;
        });
        this.shortcutAliquotaInterestadualComponent = this.$refs
            .shortcutAliquotaInterestadualComponent as ShortcutComponent;

        this.shortcutAliquotaInterestadualComponent.show();
    }

    private onInclusaoMarkupDinamico() {
        const produtoMarkupDinamico = new ProdutoMarkupDinamicoModel();
        produtoMarkupDinamico.produtoId = this.model.id;
        produtoMarkupDinamico.demaisValores = this.model.produtoMarkupDinamico.length == 0;

        this.model.produtoMarkupDinamico.push(produtoMarkupDinamico);
    }

    private onRemoveFormaFarmaceutica(model: FormaFarmaceuticaModel) {
        this.model.formasFarmaceuticas = this.model.formasFarmaceuticas.filter(p => p != model);
    }

    private onRemoveProdutoAssociacoes(model: ProdutoAssociacaoModel) {
        this.model.produtoAssociacoes = this.model.produtoAssociacoes.filter(p => p != model);
    }

    private onRemoveProdutoSinonimos(model: ProdutoSinonimoModel) {
        this.model.produtoSinonimos = this.model.produtoSinonimos.filter(p => p != model);
    }

    private onRemoveProdutoObservacoes(model: ProdutoObservacoesModel) {
        this.model.produtoObservacoes = this.model.produtoObservacoes.filter(p => p != model);
    }

    private onRemoveProdutoIncompativel(model: IncompatibilidadeProdutoModel) {
        this.model.produtosIncompativeis = this.model.produtosIncompativeis.filter(p => p != model);
        this.loadProdutosIncompatibilidadeOptions();
    }

    private onRemoveKitEmbalagemIncompativel(model: IncompatibilidadeKitEmbalagemModel) {
        this.model.kitEmbalagemIncompatibilidade = this.model.kitEmbalagemIncompatibilidade.filter(p => p != model);
        this.loadKitEmbalagemIncompatibilidadeOptions();
    }

    private async onRemoverProdutoRefrigeradoFormaFarmaceutica(model: ProdutoRefrigeradoFormaFarmaceuticaModel) {
        this.model.produtoRefrigeradoFormaFarmaceutica = this.model.produtoRefrigeradoFormaFarmaceutica.filter(
            p => p != model,
        );
        await this.loadProdutosRefrigeradosOptions();
    }

    private async onRemoverProdutoPerecivelFormaFarmaceutica(model: ProdutoPerecivelFormaFarmaceuticaModel) {
        this.model.produtoPerecivelFormaFarmaceutica = this.model.produtoPerecivelFormaFarmaceutica.filter(
            p => p != model,
        );
        await this.loadProdutosPereciveisOptions();
    }

    private onRemoverProdutoFornecedor(model: ProdutoFornecedorModel) {
        this.model.produtoFornecedores = this.model.produtoFornecedores
            .filter(p => p != model)
            .map((item, index) => {
                item.ordem = index + 1;
                return item;
            });

        this.loadFornecedoresOptions();
    }

    private onRemoveFormaFormaceuticaValidade(model: ValidadeFormaFarmaceuticaProdutoModel) {
        this.model.validadesFormasFarmaceuticasProdutos = this.model.validadesFormasFarmaceuticasProdutos.filter(
            p => p != model,
        );
    }

    private onRemoveAliquotaInterestadual(model: ProdutoAliquotaInterestadualModel) {
        this.model.produtoAliquotasInterestaduais = this.model.produtoAliquotasInterestaduais.filter(p => p != model);
        this.loadUfsAliquotasInterestaduais();
    }

    private onRemoveMarkupDinamico(model: ProdutoMarkupDinamicoModel) {
        this.model.produtoMarkupDinamico = this.model.produtoMarkupDinamico.filter(p => p != model);
    }

    private async onExtraAction(name: string, model: ProdutoLoteModel) {
        if (name.trim() == "ver") {
            this.onVer(model);
        } else if (name.trim() == "imprimir-rotulo") {
            this.onImprimirRotulo(model);
        } else if (name.trim() == "definir-lote") {
            if (model.id === this.model.lotePadraoId) {
                this.model.lotePadraoId = null;
                this.loadGridProdutoLote();
            } else {
                if (model.quantidadeAtual > 0) {
                    this.model.lotePadraoId = model.id;
                    this.loadGridProdutoLote();
                } else {
                    this.$showWarning("Atenção", "Este lote não possui quantidade.");
                }
            }
        }
    }

    private onExtraActionsProdutoFornecedor(name: string, campo: ProdutoFornecedorModel) {
        if (name.trim() == "up") {
            this.model.produtoFornecedores = changePosition(this.model.produtoFornecedores, campo, "UP");
        }

        if (name.trim() == "down") {
            this.model.produtoFornecedores = changePosition(this.model.produtoFornecedores, campo, "DOWN");
        }
        this.loadGridProdutoFornecedores();
    }

    private loadGridProdutoFornecedores(ordenar = false) {
        if (ordenar) {
            this.model.produtoFornecedores = this.model.produtoFornecedores
                .sort((a, b) => a.ordem - b.ordem)
                .map((item, index) => {
                    item.ordem = index + 1;
                    return item;
                });
            return this.addGridExtraActions();
        }

        this.model.produtoFornecedores = this.model.produtoFornecedores.map((item, index) => {
            item.ordem = index + 1;
            return item;
        });
        this.addGridExtraActions();
    }

    private addGridExtraActions() {
        this.extraActionsUp.splice(0);
        this.extraActionsDown.splice(0);
        this.extraActionsProdutoFornecedor.splice(0);

        for (let i = 0; i < this.model.produtoFornecedores.length; i++) {
            this.extraActionsUp.push(
                new GridAction("up", "Colocar para cima", "fa fa-arrow-up", GridColors.DARKGRAY, true),
            );
            this.extraActionsDown.push(
                new GridAction("down", "Colocar para baixo", "fa fa-arrow-down", GridColors.DARKGRAY, true),
            );
        }

        this.extraActionsProdutoFornecedor.push(this.extraActionsUp);
        this.extraActionsProdutoFornecedor.push(this.extraActionsDown);
    }

    loadGridProdutoLote() {
        this.gridExtraActionsVer.splice(0);
        this.gridExtraActionsImprimirRotulo.splice(0);
        this.gridExtraActionsDefinirLotePadrao.splice(0);
        this.extraActions.splice(0);

        for (let i = 0; i < this.gridDataLote.length; i++) {
            const icon =
                this.gridDataLote[i].id == this.model.lotePadraoId ? "far fa-dot-circle fa-2x" : "far fa-circle fa-2x";

            this.gridExtraActionsVer.push(new GridAction("ver", "Ver Lote", "fa fa-eye", GridColors.BLUE, true));

            this.gridExtraActionsImprimirRotulo.push(
                new GridAction("imprimir-rotulo", "Imprimir R\u00F3tulo", "fa fa-tag", GridColors.GREEN, true),
            );

            this.gridExtraActionsDefinirLotePadrao.push(
                new GridAction("definir-lote", "Definir como lote padrão", icon, GridColors.BLUE),
            );
        }

        this.extraActions.push(this.gridExtraActionsVer);
        this.extraActions.push(this.gridExtraActionsImprimirRotulo);
        this.extraActions.push(this.gridExtraActionsDefinirLotePadrao);
    }

    private async onImprimirRotulo(lote: ProdutoLoteModel) {
        await this.imprimirRotuloPersonalizadoComponent.showRotuloLote(lote.id, {});
    }

    private async onVer(lote: ProdutoLoteModel) {
        this.loadLote = true;
        this.loteId = lote.id;
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = "Lote";
        this.shortcutComponent.show();
    }

    private async onAddNewPosologia(closeModal) {
        if (await this.posologiaComponent.save()) {
            closeModal();
        }
    }

    private async openComboNewPosologia() {
        this.posologiaComponent.modelId = 0;
        this.posologiaComponent.load();
    }

    private async openComboEditPosologia(id: number) {
        this.posologiaComponent.modelId = id;
        this.posologiaComponent.load();
    }

    private async onPosologiaSaveOk(modelNovaPosologia: PosologiaModel) {
        this.model.posologiaId = modelNovaPosologia.id;
    }

    get isMarkupNull() {
        return this.model.markup == null;
    }

    get isGrupoAcabado() {
        return this.model.tipoProduto == TiposProduto.Acabado;
    }

    get isGrupoAmostraGratis() {
        const grupo = this.grupoProdutoOptions.find(p => p.value == this.model.grupoProdutoId);
        return grupo?.text?.trim().toLowerCase() === "amostra grátis";
    }

    get mostrarQuantidadeMinimaAmostragemB2B() {
        return this.isEstereis && this.isGrupoAmostraGratis;
    }

    private onMarkupPadraoChange() {
        if (this.model.markup != null) {
            this.model.markup = null;
        } else {
            this.model.markup = 0;
        }

        this.calcularValorVenda();
    }

    //@ts-ignore
    @Watch("franquiaId")
    private onFranquiaChanged() {
        if (this.franquiaId > 0 && this.franquiaId != this.model.franquiaId) {
            this.loadProdutoByParent();
        }
    }

    //@ts-ignore
    @Watch("model.posologiaId")
    private onPosologiaID() {
        this.addNewId = this.model.posologiaId;
    }

    private onMarkupChanged(newValue: number, oldValue: number) {
        if (oldValue || newValue) {
            this.calcularValorVenda();
        }
    }

    private async calculaMarkupByValorVenda(newValue: number, oldValue: number) {
        if (oldValue || newValue) {
            const response = await this.$showQuestion(this.$t("__.ts.atencao"), this.$t("__.ts.desejRecalcMarkup"));
            if (response) {
                this.model.markup = await produtoService
                    .calcularMarkupByValorVenda(this.model)
                    .withLoading()
                    .resolveWithJSON<number>();
            }
        }
    }

    //@ts-ignore
    @Watch("model.custoReferencia")
    private onCustoReferenciaChanged() {
        this.calcularValorVenda();
    }
    //@ts-ignore
    @Watch("model.ignoraControleEstoque")
    private async onIgnoraControleEstoqueChanged(newValue: number) {
        if (!this.loadCompleted) return;

        if (newValue) {
            try {
                const response = await this.$showQuestion(
                    this.$t("__.ts.atencao"),
                    this.$t("__.ts.estNaoSeraControl").toString() + this.$t("__.ts.desejaRealmRemoverContr"),
                );
                if (!response) {
                    this.model.ignoraControleEstoque = false;
                }
            } catch {
                this.model.ignoraControleEstoque = false;
            }
        }
    }
    //@ts-ignore
    @Watch("model.grupoProdutoId")
    private onGrupoProdutoIdChanged() {
        const grupo = this.grupoProdutoOptions.filter(p => p.value == this.model.grupoProdutoId);
        if (grupo.length > 0) {
            this.model.tipoProduto = grupo[0].tipo;
        }

        if (!this.isGrupoAcabado) {
            this.model.naturezaOperacaoDentroEstadoId = null;
            this.model.naturezaOperacaoForaEstadoId = null;
        }

        // Só limpa por ação do usuário: durante o load as options de grupo podem
        // ainda não estar carregadas e o valor salvo seria apagado.
        if (this.loadCompleted && this.grupoProdutoOptions.length > 0 && !this.mostrarQuantidadeMinimaAmostragemB2B) {
            this.model.quantidadeMinimaAmostragemB2B = null;
        }

        switch (this.model.tipoProduto) {
            case TiposProduto.MateriaPrima:
                this.subGrupoOptions = [
                    { text: "Ativo", value: 0 },
                    { text: "Flavorizante", value: 1 },
                    { text: " Veículos/Excipientes", value: 2 },
                    { text: "Sólido", value: 8 },
                    { text: "Semissólido", value: 9 },
                    { text: "Líquido", value: 10 },
                ];
                break;
            case TiposProduto.Embalagem:
                this.subGrupoOptions = [
                    { text: "Recipiente", value: 3 },
                    { text: "Tampa", value: 4 },
                    { text: "Aplicador", value: 5 },
                    { text: "Outros", value: 6 },
                ];
                break;
            case TiposProduto.Capsula:
                this.subGrupoOptions = [{ text: "Cor", value: 7 }];
                break;
        }
    }
    // @ts-ignore
    @Watch("model.tipoFamilia")
    private onTipoFamiliaChange() {
        if (!this.loadCompleted) {
            return;
        }
        this.model.origemFamilia = null;
        this.model.familia = null;
    }

    // @ts-ignore
    @Watch("model.origemFamilia")
    private onOrigemFamiliaChange() {
        if (!this.loadCompleted) {
            return;
        }
        this.model.familia = null;
    }

    // @ts-ignore
    @Watch("model.cstPISEntrada")
    private onCSTPISEntradaChange() {
        if (!this.model.cstCOFINSEntrada) {
            this.model.cstCOFINSEntrada = this.model.cstPISEntrada;
        }
    }
    // @ts-ignore
    @Watch("model.cstPISSaida")
    private onCSTPISChange() {
        if (!this.model.cstCOFINSSaida) {
            this.model.cstCOFINSSaida = this.model.cstPISSaida;
        }
    }

    // @ts-ignore
    @Watch("usaMarkupDinamico")
    private onChangeUsaMarkupDinamico() {
        if (this.usaMarkupDinamico && this.model.produtoMarkupDinamico.length == 0) {
            this.onInclusaoMarkupDinamico();
        }
    }

    private async calcularValorVenda() {
        if (this.loadCompleted) {
            try {
                const response = await this.$showQuestion(
                    this.$t("__.ts.atencao"),
                    this.$t("__.ts.desejRecalcVlrVenda"),
                );
                if (response) {
                    this.model.valorVenda = await produtoService
                        .calcularValorVenda({
                            ...this.model,
                            markup: this.model.markup ? this.model.markup / 100 : this.model.markup,
                        } as ProdutoModel)
                        .withLoading()
                        .resolveWithJSON<number>();
                }
            } catch {}
        }
    }

    private async getSignal(unidadeMedidaId: number) {
        if (unidadeMedidaId > 0) {
            const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);
            const unMed = unidadeMedida.find(p => p.value == unidadeMedidaId);
            return unMed ? unMed.text : "";
        }

        return "";
    }

    private validarVisibilidadeBotoes(botao: string): boolean {
        if (botao == "replicar") {
            return (
                this.model.id > 0 &&
                this.VALIDAR_PERMISSAO_USUARIO("produtos", "insert") &&
                this.model.produtoPaiId == null &&
                this.isAdminFranqueador
            );
        }

        if (botao == "remover") {
            return (
                this.VALIDAR_PERMISSAO_USUARIO("produtos", "delete") &&
                this.model.id > 0 &&
                this.model.produtoPaiId != null
            );
        }
        if (botao == "anexarArquivoProduto") {
            return this.VALIDAR_PERMISSAO_USUARIO("produtos", "insert") && this.model.id > 0;
        }
    }

    private async onReplicar(ids: Array<number>) {
        this.replicarProdutoComponent = this.$refs.replicarProdutoComponent as ReplicarProdutoComponent;
        this.replicarProdutoComponent.open();
    }

    private async onConfirmReplicarProdutos(ids: Array<number>) {
        this.filtroVinculos = ids.reduce((a, b) => a + b, 0);
        this.replicarSelecaoFranquiaComponent = this.$refs
            .replicarSelecaoFranquiaComponent as ReplicarSelecaoFranquiaComponent;
        this.replicarSelecaoFranquiaComponent.openFranquias();
    }

    private async onConfirmReplicar(franquiasIds: Array<number>) {
        const idsFranquias = franquiasIds.toString();
        try {
            const sucesso = await produtoService
                .replicar(this.model.id, idsFranquias, this.filtroVinculos)
                .withLoading()
                .resolveWithoutJSON();
            if (sucesso) {
                this.$showSuccess("Replicou", this.$t("__.ts.regisSalvosSucess"));
            }
        } catch {}
    }

    private async loadFranquias() {
        if (this.isAdmin) {
            try {
                const franquias = await franquiaService.comboCached(this.usuarioLogado.franquiaId!);
                this.franquiaOptions = franquias.map(item => ({
                    value: item.id,
                    text: item.nomeFantasia,
                }));
            } catch {}
        }
    }

    private async loadProdutoByParent() {
        if (this.modelId > 0 && this.franquiaId > 0) {
            this.loadCompleted = false;

            try {
                const data = await produtoService
                    .getByParent(this.modelId, this.franquiaId)
                    .withLoading()
                    .resolveWithJSON<ProdutoModel>();

                this.model = new ProdutoModel();
                this.model.updateFrom(data);
                this.franquiaId = data.franquiaId;
                this.validadesOriginais = this.getStringsValidades();

                setTimeout(() => {
                    this.loadCompleted = true;
                }, 250);
            } catch {
                this.loadCompleted = true;
            }
        }
    }

    private onFechar() {
        this.loadLote = false;
        this.shortcutComponent.hide();
    }

    private async onDelete() {
        try {
            const response = await this.$showQuestion(
                this.$t("__.ts.desejaExcl") + this.model.descricao + "?",
                this.$t("__.ts.acaoNaoRevert"),
            );
            if (response) {
                const sucesso = await produtoService.delete(this.model.id, this.usuarioLogado.franquiaId);

                if (sucesso) {
                    this.$showExclusao();
                    this.$router.back();
                }
            }
        } catch {}
    }

    @Watch("model.unidadeMedidaEstoqueId")
    private async onChangeUnidadeMedidaEstoqueId() {
        if (this.model.unidadeMedidaEstoqueId > 0) {
            const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

            const unMed = unidadeMedida.find(p => p.value == this.model.unidadeMedidaEstoqueId);
            this.unidadeMedidaEstoqueDescricao = unMed ? unMed.text : "";
        }
    }

    @Watch("model.unidadeMedidaManipulacaoId")
    private async onChangeUnidadeMedidaManipulacaoId() {
        if (this.model.unidadeMedidaManipulacaoId > 0) {
            const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

            const unMed = unidadeMedida.find(p => p.value == this.model.unidadeMedidaManipulacaoId);
            this.unidadeMedidaManipulacaoDescricao = unMed ? unMed.text : "";
        }
    }

    private async verLogAlteracao() {
        this.showLog = true;

        while (!this.$refs.shortcutLogComponent) await Delay(5);
        this.shortcutLogComponent = this.$refs.shortcutLogComponent as ShortcutComponent;

        while (!this.$refs.produtoLogFinanceiroComponent) await Delay(5);
        this.produtoLogFinanceiroComponent = this.$refs.produtoLogFinanceiroComponent as ProdutoLogFinanceiroComponent;

        this.shortcutLogComponent.title = this.$t("__.ts.logAltValores").toString();

        const modelAtualLog = new ProdutoLogFinanceiroModel();
        modelAtualLog.produtoId = this.model.id;
        modelAtualLog.custoMedio = this.model.custoMedio;
        modelAtualLog.custoReferencia = this.model.custoReferencia;
        modelAtualLog.markup = this.model.markup;
        modelAtualLog.valorCusto = this.model.valorCusto;
        modelAtualLog.valorVenda = this.model.valorVenda;

        this.produtoLogFinanceiroComponent.loadByProduto(modelAtualLog);

        this.shortcutLogComponent.show();
    }

    private onCloseLog() {
        this.shortcutLogComponent.hide();
    }

    private async onFichaTecnica() {
        this.loadFichaTecnicaComponent = true;

        this.shortcutFichaTecnicaComponent = this.$refs.shortcutFichaTecnicaComponent as ShortcutComponent;
        this.shortcutFichaTecnicaComponent.title = "FICHA TÉCNICA";
        this.shortcutFichaTecnicaComponent.show();

        while (!this.$refs.fichaTecnicaComponent) await Delay(5);
        this.fichaTecnicaComponent = this.$refs.fichaTecnicaComponent as FichaTecnicaEditComponent;

        this.fichaTecnicaComponent.loadFicha(this.model.id);
    }

    private async onSaveFichaTecnica() {
        if (await this.fichaTecnicaComponent.save()) {
            this.shortcutFichaTecnicaComponent.hide();
        }
    }

    private onExtraButtonActionFichaTecnica(name: string) {
        if (name == "imprimir") {
            this.fichaTecnicaComponent.imprimir();
        }
        if (name == "resultados") {
            this.fichaTecnicaComponent.resultados();
        }
    }

    private async onTrocarUnidadeMedidaEstoque() {
        this.unidadeMedidaEstoqueIdDestino = null;

        this.shortcutTrocarUnidadeMedidaComponent.title = this.$t(
            "__.Crud.produto.edit_vue_html.trocarUnidadeMedidaEstoque",
        ) as string;
        this.shortcutTrocarUnidadeMedidaComponent.show();
    }

    private async onShowUploadAnexo() {
        while (!this.$refs.uploadAnexoComponent) await Delay(50);
        this.uploadAnexoComponent = this.$refs.uploadAnexoComponent as UploadAnexoComponent;
        this.uploadAnexoComponent.show();
    }

    private async onSucessoSave(id?: number) {
        if (this.uploadAnexoComponent) {
            this.uploadAnexoComponent.onSucessoSave(id);
        }
    }

    private async onSaveTrocarUnidadeMedidaEstoque() {
        if (!this.unidadeMedidaEstoqueIdDestino) {
            return this.$showWarning(this.$t("__.ts.atencao"), "Selecione a unidade de medida de destino");
        }

        try {
            const sucesso = await produtoService
                .trocarUnidadeMedidaEstoque(this.model.id, this.unidadeMedidaEstoqueIdDestino)
                .withLoading();

            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.sucesso"), "Unidade de Medida de Estoque trocada com sucesso");

                this.loadCompleted = false;
                await this.load();
                this.loadCompleted = true;
            }
        } catch {}

        this.shortcutTrocarUnidadeMedidaComponent.hide();
    }

    private async mounted() {
        this.posologiaComponent = this.$refs.posologiaComponent as PosologiaComponent;
        this.shortcutTrocarUnidadeMedidaComponent = this.$refs
            .shortcutTrocarUnidadeMedidaComponent as ShortcutComponent;
        this.imprimirRotuloPersonalizadoComponent = this.$refs
            .imprimirRotuloPersonalizadoComponent as ImprimirRotuloPersonalizadoComponent;

        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        this.isAdminFranqueador = await this.HAS_PERMISSAO_PERFIL(false, true, false);
        this.isAdminSuporteFranqueado = await this.HAS_PERMISSAO_PERFIL(false, true, true);

        this.somenteConsulta = this.VALIDAR_PERMISSAO_SOMENTE_CONSULTA("produtos");
        this.showFinanceiro = this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", "ConferirCustosManipulacao");
        this.hasCodigoFranquiaModeloEdit = this.VALIDAR_PERMISSAO_USUARIO("produtos", "EditarCodigoFranquiaModelo");

        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        this.isIndustria = (await this.GET_IS_FRACIONAMENTO()) || (await this.GET_IS_ESTEREIS());
        if (
            !this.$route.params.id &&
            this.isIndustria &&
            !this.VALIDAR_PERMISSAO_USUARIO("produtos", "InsertProdutoIndustria")
        ) {
            await this.$showWarning(
                this.$t("__.ts.atencao") as string,
                "Não é possível criar um novo produto nesta franquia.",
            );
            this.$router.back();
            return;
        }

        const response = await Promise.all([
            unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId!),
            formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId!, this.$route.params.id ? false : true),
            kitEmbalagemService.comboCached(this.usuarioLogado.franquiaId!),
            produtoService.comboCached(this.usuarioLogado.franquiaId!),
            capsulaService.comboCached(this.usuarioLogado.franquiaId!),
            estoqueService.comboCached(this.usuarioLogado.franquiaId!),
            grupoProdutoService.comboCached(this.usuarioLogado.franquiaId!),
            farmacopeiaService.comboCached(this.usuarioLogado.franquiaId!),
            corService.comboCached(this.usuarioLogado.franquiaId!),
            codigoSiproquimService.comboCached(this.usuarioLogado.franquiaId!),
            cestService.comboCached(this.usuarioLogado.franquiaId!),
            nbmService.comboCached(this.usuarioLogado.franquiaId!),
            produtoDciService.comboCached(this.usuarioLogado.franquiaId!),
            produtoDcbService.comboCached(this.usuarioLogado.franquiaId!),
            listaControladoService.comboCached(this.usuarioLogado.franquiaId!),
            setorService.comboCached(this.usuarioLogado.franquiaId!),
            naturezaOperacaoService.comboCached(this.usuarioLogado.franquiaId!),
            this.loadFornecedoresOptions(),
            this.loadFranquias(),
            this.loadProdutosIncompatibilidadeOptions(),
            this.loadFormaFarmaceuticaIncompatibilidadeOptions(),
            this.loadProdutosRefrigeradosOptions(),
            this.loadProdutosPereciveisOptions(),
            this.loadFranquiaModeloCombo(),
            this.load(),
        ]).withLoading();

        this.unidadesMedidaOptions = response[0];
        this.formasFarmaceuticaOptions = response[1];
        this.kitEmbalagemOptions = response[2];
        this.produtoAssOptions = response[3];
        this.produtoDiluidoOptions = response[3].filter(p => p.value != this.model.id);
        this.capsulasOptions = response[4];
        this.estoquesOptions = response[5];
        this.grupoProdutoOptions = response[6];
        this.farmacopeiaOptions = response[7];
        this.coresOptions = response[8];
        this.codigoSiproquimOptions = response[9];
        this.cestsOptions = response[10];
        this.nbmsOptions = response[11];
        this.dcisOptions = response[12];
        this.dcbsOptions = response[13];
        this.listasControladoOptions = response[14];
        this.setorOptions = response[15];
        this.naturezaOperacaoOptions = response[16];

        this.loadKitEmbalagemIncompatibilidadeOptions();

        try {
            this.loadCSTs();

            if (this.$route.params.id) {
                this.modelId = +this.$route.params.id;
                this.load();
            } else {
                if (this.isModal && this.descricaoSugestao != null) {
                    this.model.descricao = this.descricaoSugestao;
                }
                this.loadCompleted = true;
            }
        } catch {
            this.loadCompleted = true;
        }
    }
}
